import moment from "moment";
import { baseAxios, errorHandler } from "../index";

export async function getOperationalSummary(dispatch) {
  try {
    const response = await baseAxios.post("webDashboard/operationalSummary", {}, {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_OPERATIONAL_SUMMARY", data: response.data.data });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function totalPenyaluran(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalPenyaluran",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_PENYALURAN", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function totalNominalLunas(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalNominalLunas",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_NOMINAL_LUNAS", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function totalNominalOngoing(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalNominalOngoing",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_NOMINAL_ONGOING", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function totalAllPengajuan(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalAllPengajuan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_ALL_PENGAJUAN", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function getTotalKaryawan(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webDashboard/totalKaryawan", {}, {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_TOTAL_KARYAWAN", data: response.data });

    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function totalSimpanan(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webDashboard/totalSimpanan", data, {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_TOTAL_SIMPANAN", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function getProfitPugar(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webDashboard/profitPugar", data, {
      headers: { token: localStorage.getItem("token") },
    });

    if (data.type === "nominal") {
      dispatch({
        type: "GET_PROFIT_PUGAR_NOMINAL_SUCCESS",
        data: response.data,
      });
    }

    if (data.type === "kuantiti") {
      dispatch({
        type: "GET_PROFIT_PUGAR_KUANTITI_SUCCESS",
        data: response.data,
      });
    }
    dispatch({ type: "SET_GRAND_TOTAL_PROFIT", data: response.data });

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getPengajuanTrend(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/getPengajuanTrend",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    if (data.type === "nominal") {
      dispatch({
        type: "GET_TREND_PUGAR_NOMINAL_SUCCESS",
        data: response.data,
      });
    }

    if (data.type === "kuantiti") {
      dispatch({
        type: "GET_TREND_PUGAR_KUANTITI_SUCCESS",
        data: response.data,
      });
    }

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getNominalProfitPugar(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/nominalProfitPugar",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    if (data.type === "nominal") {
      dispatch({
        type: "GET_PROFIT_NOMINAL_PUGAR_NOMINAL_SUCCESS",
        data: response.data,
      });
    }

    if (data.type === "kuantiti") {
      dispatch({
        type: "GET_PROFIT_NOMINAL_PUGAR_KUANTITI_SUCCESS",
        data: response.data,
      });
    }
    dispatch({ type: "SET_GRAND_TOTAL_PROFIT", data: response.data });

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getUserTrend(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/userjoinexit",
      {
        start: "2024-01-01",
        end: moment(new Date()).format("YYYY-MM-DD"),
      },
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    dispatch({
      type: "SET_USER_TRACK",
      data: response.data.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getHistoryUserJoinExit(data) {
  try {
    const response = await baseAxios.get(
      `webDashboard/history-user-join-exit?start=${data.start}&end=${data.end}&type=${data.type}&cari=${encodeURIComponent(data.cari || "")}&page=${data.page}&limit=${data.limit}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function exportHistoryUserJoinExit(data) {
  try {
    const response = await baseAxios.get(
      `webDashboard/history-user-join-exit/export?start=${data.start}&end=${data.end}&type=${data.type}&cari=${encodeURIComponent(data.cari || "")}`,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getPengajuanTrack(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/historyPengajuan",
      {
        start: "2024-01-01",
        end: moment(new Date()).format("YYYY-MM-DD"),
      },
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    dispatch({
      type: "SET_PENGAJUAN_TRACK",
      data: response.data.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getRekapSimpanan(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/rekapSimpanan",
      {},
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    // console.log(response, "rekap simpanan");
    dispatch({
      type: "SET_REKAP_SIMPANAN",
      data: response.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getRekapAdministrasi(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/historyAdmin",
      {},
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    // console.log(response, "rekap admin");
    dispatch({
      type: "SET_REKAP_ADMIN",
      data: response.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getRekapReport(dispatch, data, history) {
  try {
    console.log(data, "dari function tes bulan tahun");
    const response = await baseAxios.post(
      "webDashboard/getPengajuanCairPerTanggal",
      {
        tglAwal: data.tgl,
        tglAkhir: data.tgl,
      },
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    console.log(response, "respon tes bulan tahun");
    dispatch({
      type: "SET_REKAP_REPORT",
      data: response.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function syncDashboardCronJobs() {
  try {
    const response = await baseAxios.post(
      "webDashboard/sinkronCronDashboard",
      {},
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}
